import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Store } from '@ngrx/store';
import { distinctUntilChanged, Observable, switchMap, tap } from 'rxjs';

import { Vehicle } from 'src/app/api/owcc/models';
import { fromRegion } from 'src/app/store/mbcc/mbcc.selectors';

interface HeaderInfoState {
  vehicle?: Vehicle;
  isVehicleRequestTriggeredByPostalCodeChangeInProgress: boolean;
}

const defaultHeaderInfoState: HeaderInfoState = {
  vehicle: undefined,
  isVehicleRequestTriggeredByPostalCodeChangeInProgress: false
};

@Injectable()
export class HeaderInfoStore extends ComponentStore<HeaderInfoState> {
  public readonly vehicle$ = this.select(state => state.vehicle);
  public readonly isVehicleRequestTriggeredByPostalCodeChangeInProgress$ = this.select(
    state => state.isVehicleRequestTriggeredByPostalCodeChangeInProgress
  );

  /**
   * Vehicle might not have a price (e.g. Australia if no region selected)
   */
  public readonly hasVehicleAPrice$ = this.select(this.vehicle$, vehicle => !!vehicle?.priceInformation);

  public readonly observePostalCodeChange = this.effect(trigger$ =>
    trigger$.pipe(
      switchMap(() => this.store.select(fromRegion.selectPostalCode)),
      distinctUntilChanged(),
      tap(() => {
        this.patchState({ isVehicleRequestTriggeredByPostalCodeChangeInProgress: true });
      })
    )
  );

  public readonly updateVehicle = this.effect((vehicle$: Observable<Vehicle>) =>
    vehicle$.pipe(
      tap(vehicle => {
        this.patchState({ vehicle, isVehicleRequestTriggeredByPostalCodeChangeInProgress: false });
      })
    )
  );

  public constructor(private readonly store: Store) {
    super(defaultHeaderInfoState);
    this.observePostalCodeChange();
  }
}
